import PropTypes from 'prop-types';
import useCompany from '../hooks/useCompany';
import CustomNavigate from '../components/CustomNavigate';

export default function SSOModuleMiddleware({ children }) {
    const { activeCompany } = useCompany();

    if (!activeCompany) return <CustomNavigate to="/dashboard/home" />;

    const modules = activeCompany?.modules || [];

    const hasSSOModule = modules.some((module) =>
        typeof module === 'string' ? module === 'sso_module' : module.slug === 'sso_module'
    );

    if (!hasSSOModule) return <CustomNavigate to="/dashboard/home" />;

    return children;
}

SSOModuleMiddleware.propTypes = {
    children: PropTypes.node.isRequired,
};
